import React from 'react';
import { IconProps } from '.';

const SvgVideo = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M18 14.5V19H2V5h16v4.5l4.5-3v11l-4.5-3Zm-14.5-8h13v11h-13v-11ZM18 12.78l3 1.911V9.305l-3 1.916v1.558Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgVideo;
